const elemTextWithImage = document.querySelectorAll('.wt-TextWithImage');
window.fireOnVisible(elemTextWithImage, async () => {
    await import('./assets/css/textwithimage.scss');
});
